export {
    getAutordata,
    filialabholungAngezeigt
}

function getAutordata(autoren, key) {
    const data = [];
    for (const autor of autoren) {
        data.push(autor[key]);
    }
    return data;
}

function filialabholungAngezeigt() {
    return document.querySelector('[component="filialabholung-box"]') !== null;
}

